import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { MaterialIcon } from '@dsny/dsny-component-library'
import PlaylistActionsMenuContent, {
  actionPropTypes
} from './PlaylistActionsMenuContent'
import styles from './PlaylistActionsMenu.module.scss'

const PlaylistMoreActionsDropdown = ({
  isPlayDisabled,
  onDownloadMp3,
  onDownloadPdf,
  onDownloadWav,
  onOpenChange,
  onPlay,
  onRemove
}) => {
  const { t } = useTranslation()
  const openedWithPointerRef = useRef(false)
  const triggerRef = useRef(null)

  const handleCloseAutoFocus = (event) => {
    if (!openedWithPointerRef.current) return

    event.preventDefault()
    triggerRef.current?.blur()
    openedWithPointerRef.current = false
  }

  const handleClick = (event) => event.stopPropagation()

  const handleKeyDown = () => {
    openedWithPointerRef.current = false
  }

  const handlePointerDown = (event) => {
    event.stopPropagation()
    openedWithPointerRef.current = true
  }

  return (
    <DropdownMenu.Root onOpenChange={onOpenChange}>
      <DropdownMenu.Trigger
        ref={triggerRef}
        aria-label={t('general.more-actions')}
        className={styles.moreActionsTrigger}
        data-cy="playlist-more-actions"
        type="button"
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        onPointerDown={handlePointerDown}>
        <MaterialIcon color="currentColor" name="MoreVertical" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          avoidCollisions
          align="end"
          className={styles.menuContent}
          collisionPadding={8}
          data-cy="playlist-more-actions-menu"
          side="bottom"
          sideOffset={5}
          onCloseAutoFocus={handleCloseAutoFocus}
          onClick={handleClick}>
          <PlaylistActionsMenuContent
            isPlayDisabled={isPlayDisabled}
            Menu={DropdownMenu}
            onDownloadMp3={onDownloadMp3}
            onDownloadPdf={onDownloadPdf}
            onDownloadWav={onDownloadWav}
            onPlay={onPlay}
            onRemove={onRemove} />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

PlaylistMoreActionsDropdown.propTypes = {
  isPlayDisabled: PropTypes.bool,
  onOpenChange: PropTypes.func,
  ...actionPropTypes
}

export default PlaylistMoreActionsDropdown
